import { call, put, takeLatest } from 'redux-saga/effects'
// import { fetchFarmers } from './_requests'
import moment from 'moment'
import Axios from "axios"
import { getRegisteredFarmers, getRegisteredSuccess, getRegisteredFailed } from '../_slices/AppSlice'

let callAPI = async ( { url, method, data } ) => {
    return await Axios( {
        url,
        method,
        data
    } )
}

export function* watchFetchFarmers() {
    yield takeLatest( getRegisteredFarmers.type, getFetchFarmers )
}

export function* getFetchFarmers( action ) {
    try {
        const response = yield call( () => callAPI( { url: `https://mis.nec.go.ug/api/auth/farmer`, method: "GET" } ))
        
        if( response.data ) {
            const results = response.data.records.map( ( farmer ) => {
                return {
                    name: `${farmer.first_name?.toUpperCase()} ${farmer.last_name?.toUpperCase()}`,
                    block: farmer.block_number,
                    ffs_code: farmer.name,
                    block: farmer.block_id,
                    date: moment ( farmer.created_at ).format( "DD MMM, YYYY" ),
                    id: farmer.id,
                    district: farmer.district,
                    plotno: farmer.plot_number,
                    created_at: moment ( farmer.created_at ).format( "DD MMM, YYYY" ),
                    gender: farmer.gender,
                    registration_no: farmer.reg_number,
                    scheme: farmer.scheme,
                    status: farmer.status,
                    is_leader: farmer.is_leader,
                    position: farmer.position,
                    institution_type: farmer.institution_type,
                    institution: farmer.institution,
                    interest_group: farmer.interest_group,
                    primary_contact: farmer.primary_contact,
                    season_1: farmer.season_1,
                    season_2: farmer.season_2
                }
            } )
            .filter( item =>  { 
                return item.scheme?.toLowerCase() === localStorage.getItem( "scheme" ).replace( "_", " " )?.toLowerCase()
            } )
            .sort( ( a, b ) => {
                return moment( b.created_at ).format( "YYYYMMDDHHMM" ) - moment( a.created_at ).format( "YYYYMMDDHHMM" )
            } ).map( ( val, index ) => {
                return { ...val, fNo: index+1 } 
            } )
            
            //update state
            yield put( getRegisteredSuccess( results ) )
        }
    } catch (error) {
        yield put( getRegisteredFailed( error ) )
    }
}